import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { GoogleMapsService } from 'src/app/shared/services/google-maps.service';
import { CommonBookingService } from '../common-booking.service';
import { UtilService } from 'src/app/shared/services/util.service';

import { MapPopup } from 'src/app/shared/components/map-popup/map-popup';
import moment from 'moment-timezone';
import { TrackMarkers } from '../track-markers';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
declare const google: any;

@Component({
  selector: 'app-cab-track',
  templateUrl: './cab-track.component.html',
  styleUrls: ['./cab-track.component.scss']
})
export class CabTrackComponent implements OnInit, OnDestroy {

  @Input() booking: any;
  @Output() closeCallback = new EventEmitter();

  public track: any = {};
  public map: any;
  private timer: any;
  public showTrafficLayer: boolean;
  private directionsService: any;
  private distanceMatrixService: any;
  private infoPopup: any;
  private firstMapPlot = true;
  private destroy$ = new Subject();

  constructor(
    private googleMapsService: GoogleMapsService,
    private commonBookingService: CommonBookingService,
    private authService: AuthService,
    private utilService: UtilService,
   ) { }


  ngOnInit() {
    this.setupData();
    this.setupMap();
    this.fetchTrackInfo();
  }

  cancelCallback() {
    this.closeCallback.emit();
  }

  getStopInfo(stop) {
    let timeStr;
    timeStr = stop.time ? this.utilService.getMoment(stop.time).format('hh:mm A') : null;
    const contentString = `<div class="stop-details">
      <div class="detail-wrapper">
        <img class="detail-icon" src="assets/house-blue.svg">
        <div class="detail address">${stop.address}</div>
      </div>
      ${timeStr ?
      `<div class="detail-wrapper">
        <img class="detail-icon" src="assets/clock-blue.svg">
        <div class="detail">${timeStr}</div>
      </div>` : ''}
      <div class="detail-wrapper">
        <img class="detail-icon" src="assets/riders-blue.svg">
        <div class="detail">${stop.riders.length} rider(s)</div>
      </div>
    </div>`;

    const bubble = document.createElement('div');
    bubble.innerHTML = contentString;
    return bubble;
  }

  getCarInfo() {
    if (this.track.track.cabLocation){
      let cabLocationInfo = this.track.track.cabLocation;
      cabLocationInfo = cabLocationInfo.gpsLocation.timeStamp > cabLocationInfo.networkLocation.timeStamp ?
        cabLocationInfo.gpsLocation :
        cabLocationInfo.networkLocation;
      const cabInfo = this.track.track.cab;
      const time = moment.unix(cabLocationInfo.time / 1000);
      const contentString = `<div class="stop-details">
        <div class="detail-wrapper driver-name">${cabInfo.driverName}</div>
        <div class="detail-wrapper">
          <img class="detail-icon" src="assets/car-blue.svg">
          <div class="detail address">${cabInfo.identification}</div>
        </div>
        <div class="detail-wrapper">
          <img class="detail-icon" src="assets/steering-blue.svg">
          <div class="detail">${cabLocationInfo.mSpeed} km/h</div>
        </div>
      </div>`;

      const bubble = document.createElement('div');
      bubble.innerHTML = contentString;
      return bubble;
    } }


  setupMap() {
    const centralLocation = this.googleMapsService.convertToLatLong('12.972442, 77.580643');
    this.map = new google.maps.Map(document.getElementById('stop-location-map'), {
      zoom: 6,
      center: centralLocation,
      disableDefaultUI: true
    });

    this.directionsService = new google.maps.DirectionsService();
    this.distanceMatrixService = new google.maps.DistanceMatrixService();
    this.infoPopup = new MapPopup(centralLocation, document.createElement('div'), 'detailed');
  }

  setupData() {
      this.track = {
        checked: true,
        nextSequenceId: 0,
        lastUpdated: null,
        markers: [],
        stopGeoCords: [],
        allMileStones: [],
        cab: this.booking.cab,
        directionsRenderer: this.googleMapsService.getNewDirectionsRenderer(),
        polyline: this.googleMapsService.getNewPolyline()
      };
      this.track.infoWindows = [];
      this.booking.stops.forEach((stop, stopIndex) => {
        if (!stop.geoCord) { return; }
        const latLng = this.googleMapsService.convertToLatLong(stop.geoCord);
        const marker = new google.maps.Marker({
          icon: {
            url: this.getIconSrc(stopIndex)
          },
          position: latLng
        });
        this.track.markers.push(marker);
        if (stopIndex > -1){
          // Creating Infowindow for each stop to show ETA
          const popup = new MapPopup(latLng, document.createElement('div'), 'tiny');
          const infoWindowContent = document.createElement('div');
          infoWindowContent.innerHTML = 'Stop - ' + stopIndex;
          popup.updatePopup({content: infoWindowContent});
          this.track.infoWindows.push(popup);
        }
        google.maps.event.addListener(marker, 'mouseover', this.onStopMarkerMousover.bind(this, marker, stop));
        google.maps.event.addListener(marker, 'mouseout', this.onStopMarkerMouseout.bind(this, marker));
        this.track.stopGeoCords.push({index: stopIndex, latLng, stopId: stop.id});
      });
      const content = document.createElement('div');
      this.track.nextStopInfo = new MapPopup(this.track.stopGeoCords[0].latLng, content, 'tiny');
      this.track.isTrackable = this.track.stopGeoCords.length;
    }

  getIconSrc(stopIndex) {
    if (stopIndex === 0 ) {
      return 'assets/pickup-marker.svg';
    } else if (stopIndex === this.booking.stops.length - 1) {
      return 'assets/drop-marker.svg';
    } else {
      return 'assets/stop-marker.svg';
    }
  }


  addCarEventListener(marker) {
    google.maps.event.addListener(marker, 'mouseover',
        this.onCarMarkerMousover.bind(this, marker));
    google.maps.event.addListener(marker, 'mouseout', this.onStopMarkerMouseout.bind(this, marker));

  }

  removeInstanceEventListener(marker) {
    google.maps.event.clearListeners(marker);
  }

  onCarMarkerMousover(marker) {
    this.infoPopup.updatePopup({
      position: marker.getPosition(),
      content: this.getCarInfo()
    });
    this.infoPopup.setMap(this.map);
  }

  onStopMarkerMousover(marker, stop) {
    this.infoPopup.updatePopup({
      position: marker.getPosition(),
      content: this.getStopInfo(stop)
    });
    this.infoPopup.setMap(this.map);
  }

  onStopMarkerMouseout(marker) {
    this.infoPopup.setMap(null);
  }

  fetchTrackInfo() {
    const request = [{
      bookingID: this.booking.bookingId,
      sequenceID: this.track.nextSequenceId,
      buId: this.authService.user.buId
    }];
    if (request.length) {
      this.clearTimer();
      this.commonBookingService.getBookingTrack(request).
      pipe(
        takeUntil(this.destroy$),
      ).
      subscribe((response) => {
        const bookingTrackResponse = response[0];
        if (bookingTrackResponse) {
          this.track.track = bookingTrackResponse;
          this.track.currentStatus = bookingTrackResponse.currentStatus;
          this.track.nextSequenceId = bookingTrackResponse.sequenceId;
          this.track.cabUpcomingStop = bookingTrackResponse.cabUpcomingStop;

          bookingTrackResponse.mileStones.forEach((milestone) => {
            this.track.allMileStones.push(this.convertMilestoneToLatLng(milestone));
          });
          // if (bookingTrackResponse.mileStones.length || this.firstMapPlot) {
          this.showBookingTrack();
          // }
          if (this.track.track.currentStatus !== 'TRIP_COMPLETED' && this.track.track.currentStatus !== 'DUTY_COMPLETED') {
            this.setTimer();
          }
        }
        this.showBookingPlannedPath();

      },
      (error) => {
        // if (error.status === 504) {
        //   this.fetchTrackInfo();
        // }
        this.setTimer();
        this.showPathBeforeTripStart();
      }
      );
    }
  }

  focusMap() {
    const bounds = new google.maps.LatLngBounds();
    const cabLocation = this.getCabLocation();
    if (cabLocation) {
     bounds.extend(cabLocation);
    }
    this.track.stopGeoCords.forEach((stopGeoCord: any) => {
      bounds.extend(stopGeoCord.latLng);
    });
    this.map.fitBounds(bounds);
  }

  setTimer() {
    if (this.timer) {
      this.clearTimer();
    }
    this.timer = setTimeout(() => {
      this.fetchTrackInfo();
    }, 20000);
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  showBookingPlannedPath() {
    if (this.track.stopGeoCords.length > 1) {
      const geoCords = this.track.stopGeoCords.map(stopGepCord => stopGepCord.latLng);
      let waypoints = this.track.track && this.track.track.currentStatus === 'ON_TRIP' ? geoCords.slice(0, geoCords.length - 1) :
        geoCords.slice(1, geoCords.length - 1);
      waypoints = waypoints.map((waypoint) => {
        return {location: waypoint};
      });
      this.directionsService.route({
        origin: (this.track.track && this.track.track.currentStatus === 'DUTY_COMPLETED'
        || this.track.track && this.track.track.currentStatus === 'TRIP_COMPLETED')
        ? geoCords[0] : this.convertMilestoneToLatLng(this.track.track && this.track.track?.cabLocation?.gpsLocation),
        waypoints,
        destination: geoCords[geoCords.length - 1],
        travelMode: 'DRIVING',
        provideRouteAlternatives: false
      }, (response, status) => {
        if (status === 'OK') {
          this.track.directionsRenderer.setDirections(response);
          this.track.directionsRenderer.setMap(this.map);
        } else {
          console.warn('Directions request failed due to ' + status);
        }
      });
    }
    this.track.markers.forEach((marker) => {
      marker.setMap(this.map);
    });
    // this.track.polyline.setMap(this.map);
  }

  showPathBeforeTripStart() {
    if (this.track.stopGeoCords.length > 1) {
      const geoCords = this.track.stopGeoCords.map(stopGepCord => stopGepCord.latLng);
      let waypoints = geoCords.slice(1, geoCords.length - 1);
      waypoints = waypoints.map((waypoint) => {
        return {location: waypoint};
      });

      this.directionsService.route({
        origin: geoCords[0],
        waypoints,
        destination: geoCords[geoCords.length - 1],
        travelMode: 'DRIVING',
        provideRouteAlternatives: false
      }, (response, status) => {
        if (status === 'OK') {
          this.track.directionsRenderer.setDirections(response);
          this.track.directionsRenderer.setMap(this.map);
        } else {
          console.warn('Directions request failed due to ' + status);
        }
      });
    }
    this.track.markers.forEach((marker) => {
      marker.setMap(this.map);
    });
    // this.track.polyline.setMap(this.map);
    this.focusMap();
  }

  showBookingTrack() {
      if (!this.track.isTrackable) {
        return false;
      }
      const routePoints = this.getBookingRoutePoints();
      if (!(this.track.track.currentStatus === 'TRIP_COMPLETED') && routePoints.cabLocation && routePoints.upcomingStop !== undefined) {
        this.distanceMatrixService.getDistanceMatrix({
          travelMode: 'DRIVING',
          origins: [routePoints.cabLocation].concat(routePoints.upcomingStop),
          destinations: [routePoints.cabLocation].concat(routePoints.upcomingStop)
        }, (response) => {
          this.track.infoWindows.forEach((info, index) => {
            if (index < this.track.nextStopIndex) {
              info.setMap(null);
            } else {
              // Creating Infowindow for each stop to show ETA
              const infoWindowContent = document.createElement('div');
              // tslint:disable-next-line: max-line-length
              infoWindowContent.innerHTML = this.utilService.convertMinsToHours(parseInt((this.googleMapsService.getDistanceToAPoint(response, ((index + 1) - this.track.nextStopIndex)) / 60).toFixed()));
              info.updatePopup({content: infoWindowContent});
              info.setMap(this.map);
            }
          });
        });
       } else {
        this.track.nextStopInfo.setMap(null);
      }

      if (this.track.track.mileStones && this.track.track.cabLocation) {
        const path = this.track.polyline.getPath();
        // this.track.track.mileStones.forEach((milestone) => {
        //   path.push(this.convertMilestoneToLatLng(milestone));
        // });
        path.push(this.convertMilestoneToLatLng(this.track.track?.cabLocation?.gpsLocation));
        // this.track.polyline.setPath(path);
      }


      if (this.track.track.currentStatus === 'TRIP_COMPLETED') {
        if (this.track.carMarker) {
          this.track.carMarker.setMap(null);
          this.removeInstanceEventListener(this.track.carMarker);
        }
      } else if (routePoints.cabLocation && this.track.polyline.getPath().length) {
        if (this.track.carMarker) {
          this.track.carMarker.setMap(null);
          this.removeInstanceEventListener(this.track.carMarker);
        }
        this.track.carMarker = new google.maps.Marker({
          icon: {
            url: TrackMarkers.getTrackMarkers('car', null, routePoints.heading),
            scaledSize: {
              height: 50,
              width: 50
            }
          },
          position: routePoints.cabLocation,
          map: this.map
        });
        this.addCarEventListener(this.track.carMarker);
      }

      if (this.firstMapPlot) {
        this.firstMapPlot = false;
        this.focusMap();
      }

  }

  getCabLocation() {
    if (!this.track.track) {
      return;
    }
    if (this.track.track.currentStatus === 'DUTY_COMPLETED' || this.track.track.currentStatus === 'TRIP_COMPLETED') {
      return;
    }
    if (this.track.track.cabLocation){
   const cabLocationInfo = this.track.track.cabLocation;
   if (cabLocationInfo.gpsLocation.latitude === 0 && cabLocationInfo.gpsLocation.longitude === 0) {
      return;
    }
   if (cabLocationInfo.gpsLocation.timeStamp > cabLocationInfo.networkLocation.timeStamp) {
      return this.convertMilestoneToLatLng(cabLocationInfo.gpsLocation);
    } else {
      return this.convertMilestoneToLatLng(cabLocationInfo.networkLocation);
    }
}
  }

  getBookingRoutePoints() {
    const routePoints: any = {};
    const stopGeoCords: any[] = this.track.stopGeoCords;
    const allMileStones: any[] = this.track.allMileStones;

    if (!stopGeoCords.length  && !allMileStones.length) {
      return;
    }

    routePoints.cabLocation = this.getCabLocation();
    let upcomingStops = [];
    stopGeoCords.forEach((stopGeoCord, index) => {
      if (this.track.track.cabUpcomingStop === stopGeoCord.stopId) {
        upcomingStops = stopGeoCords.slice(index, stopGeoCords.length);
        this.track.nextStopIndex = index;
      }
    });

    // routePoints.upcomingStop = upcomingStopIndex !== undefined ?
    //   stopGeoCords[upcomingStopIndex].latLng : undefined;

    // routePoints.heading = this.googleMapsService.computeHeadingFromMilestones(allMileStones);
    routePoints.upcomingStop = [];
    upcomingStops.forEach(stop => {
      routePoints.upcomingStop.push(stop.latLng);
    });

    if (allMileStones.length > 1) {
      routePoints.heading = google.maps.geometry.spherical.computeHeading(
        allMileStones[allMileStones.length - 2],
        allMileStones[allMileStones.length - 1]
      );
    }
    return routePoints;
  }

  convertMilestoneToLatLng(milestone) {
    if (milestone) {
    return this.googleMapsService.convertToLatLong(`${milestone.latitude},${milestone.longitude}`);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.clearTimer();
  }

}
